import React from 'react'
import { useState } from 'react'
import MyButton from '../../../UI/form/MyButton'
import PackingGoodFieldScaner from './fileds/PackingGoodFieldScaner'
import { useEffect } from 'react'
import { setValueForm } from '../../../../helpers/form/FormHelper'
import { responseError } from '../../../../helpers/response/ResponseHelper'
import { packingBoxInPackByScanAPI } from '../../../../api/pack/seriesAPI'
import MySpiner from '../../../UI/spiner/MySpiner'
import MyModal from '../../../UI/modal/MyModal'
import MyModalAgry from '../../../UI/modal/MyModalAgry'

const PackingGoodsForm = () => {

    // Всі товари, що мають буи відскановані
    const [scannedGoods, setScannedGoods] = useState({
        drone: null,
        bobbin: null,
        // battery: null,
        detonation: null,
    })
    // console.log('scannedGoods', scannedGoods)
    // Товари, що отримано в результаті сканування
    const [goodsFromBd, setGoodsFromBd] = useState({
        drone: null,
        bobbin: null,
        // battery: null,
        detonation: null,
    })
    const [goodDataMain, setGoodDataMain] = useState(null)
    const [goodDataNew, setGoodDataNew] = useState(null)

    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')
    const [errorMain, setErrorMain] = useState('')
    const [loading, setLoading] = useState(false)
    const [agryResetOpen, setAgryResetOpen] = useState(false)
    const [agryReset, setAgryReset] = useState(false)

    const [reset, setReset] = useState(false)

    const [valid, setValid] = useState(false)

    useEffect(() => {
        validateForm()
    }, [goodsFromBd])

    useEffect(() => {
        if (agryReset) {
            resetData()
        }
    }, [agryReset])

    // Скидання відсканованих товарів
    const resetDataScanned = () => {
        const dataForReset = {
            drone: null,
            bobbin: null,
            // battery: null,
            detonation: null,
        }
        setScannedGoods(dataForReset)
        setGoodsFromBd(dataForReset)
        setSuccess('')
        setError('')
        setLoading(false)
    }

    const packing = () => {
        setLoading(true)
        setSuccess('')
        setError('')

        packingBoxInPackByScanAPI({
            goodsFromBd
        }).then(data => {
            console.log('Товар успішно упаковано')
            console.log('data', data)
            setSuccess('Товар успішно упаковано')
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    // const getDataBd = () => {

    // }

    // Перевіряємо наявність всіх отриманих товарів з БД після сканування
    const validateForm = () => {
        let validTemp = true

        if (goodsFromBd) {
            const keys = Object.keys(goodsFromBd)
            for (const key of keys) {
                if (!goodsFromBd[key]) {
                    validTemp = false
                }
            }
        } else {
            validTemp = false
        }

        setValid(validTemp)
    }

    const resetDataCheck = () => {
        if (scannedGoods.drone || scannedGoods.bobbin || scannedGoods.battery || scannedGoods.detonation) {
            setAgryResetOpen(true)   
        } else {
            setAgryResetOpen(false)
            setAgryReset(true)
        }
    }

    const resetData = () => {
        resetDataScanned()
        setError('')
        setErrorMain('')
        setReset(true)

        setAgryReset(false)
    }

  return (
    <div className='myBlock__content'>
        <p>
            В цьому розділі відбувається пакування товарів у кінцеву партію для відгрузки
		</p>
        <p>
            Для пакування товарів скануйте відповідні товари згідно інструкції нижче
		</p>

        <MyModalAgry
            open={agryResetOpen}
            setOpen={setAgryResetOpen}
            header={'Ви не підтвердили пакування коробки'}
            content={
                <div>
                    <p>Ви впевнені, що хочете скинути всі відскановані дані?</p>
                </div>
            }
            disableClickOutside={true}
            setIsAgry={setAgryReset}
        />

        {
			scannedGoods.drone || scannedGoods.bobbin || scannedGoods.battery || scannedGoods.detonation || errorMain ?
				<MyButton
					color='red'
					// onClick={reset}
					onClick={e => {
                        resetDataCheck()
					}}
				>
					Сканувати з початку
				</MyButton>
			: ''
		}

        <PackingGoodFieldScaner 
            valueScan={scannedGoods.drone}
            setValueScan={e => {
                setValueForm(setScannedGoods, 'drone', e)
            }}
            setGoodsFromBd={e => {
                setValueForm(setGoodsFromBd, 'drone', e)
            }}
            reset={reset}
            setReset={setReset}
            // setScannedGood={e => setValueForm(setScannedGoods, 'drone', e)}
            header='1. Зчитати QR-код дрону'
            goodType='drone'
            goodsFromBd={goodsFromBd}
        />

        <PackingGoodFieldScaner 
            valueScan={scannedGoods.bobbin}
            setValueScan={e => {
                setValueForm(setScannedGoods, 'bobbin', e)
            }}
            setGoodsFromBd={e => {
                setValueForm(setGoodsFromBd, 'bobbin', e)
            }}
            reset={reset}
            setReset={setReset}
            // setScannedGood={e => setValueForm(setScannedGoods, 'bobbin', e)}
            header='2. Зчитати QR-код котушки'
            goodType='bobbin'
            goodsFromBd={goodsFromBd}
        />

        {/* <PackingGoodFieldScaner 
            valueScan={scannedGoods.battery}
            setValueScan={e => {
                setValueForm(setScannedGoods, 'battery', e)
            }}
            setGoodsFromBd={e => {
                setValueForm(setGoodsFromBd, 'battery', e)
            }}
            reset={reset}
            setReset={setReset}
            setScannedGood={e => setValueForm(setScannedGoods, 'battery', e)}
            header='3. Зчитати QR-код батарейки'
            goodType='battery'
            goodsFromBd={goodsFromBd}
        /> */}

        <PackingGoodFieldScaner 
            valueScan={scannedGoods.detonation}
            setValueScan={e => {
                setValueForm(setScannedGoods, 'detonation', e)
            }}
            setGoodsFromBd={e => {
                setValueForm(setGoodsFromBd, 'detonation', e)
            }}
            reset={reset}
            setReset={setReset}
            setScannedGood={e => setValueForm(setScannedGoods, 'detonation', e)}
            // header='4. Зчитати QR-код плати ініціації'
            header='3. Зчитати QR-код плати ініціації'
            goodType='detonation'
            goodsFromBd={goodsFromBd}
        />

        <p>
            <b>Важливо!</b> Підтверджуючи упаковку коробки Ви так само підтверджуєте, що в коробку поклали всі необхідні компоненти. В тому числі й батарейку
        </p>

        {
			success ?
				<div className='success'>
					{success}
				</div>
			: ''
		}

		{
			error ?
				<div className='error'>
					{error}
				</div>
			: ''
		}

        {
            loading ? <MySpiner /> : ''
        }

		{
			// goodDataMain && goodDataNew ?
				<MyButton
					onClick={packing}
					disabled={loading || !valid || success ? true : false}
				>
					Підтвердити пакування коробки
				</MyButton>
			// : ''
		}
    </div>
  )
}

export default PackingGoodsForm